import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import BsiIcon, { buttonIcon } from './BsiIcon';
import { t } from '../helpers';
const topics = [['file', 'file-code'], ['quote', 'receipt'], ['result', 'download-simple']];

// Public explanatory content. The illustration accepts no files and displays
// neither a real order nor a simulated processing status.
export default class HomeWorkbench extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.openTopic = null;
  }
  view() {
    const active = this.openTopic || 'idle';
    return m("section", {
      className: 'BsiWorkbench BsiWorkbench--' + active,
      "aria-labelledby": "bsi-workbench-title"
    }, m("div", {
      className: "BsiWorkbench-copy"
    }, m("span", {
      className: "BsiEyebrow"
    }, t('home.workbench_eyebrow')), m("h2", {
      id: "bsi-workbench-title"
    }, t('home.workbench_title')), m("div", {
      className: "BsiWorkbench-questions"
    }, topics.map(_ref => {
      let [topic, icon] = _ref;
      return m("div", {
        className: 'BsiWorkbench-item' + (this.openTopic === topic ? ' is-open' : ''),
        key: topic
      }, m("h3", null, m(Button, {
        className: "Button Button--link BsiWorkbench-question",
        icon: buttonIcon(icon),
        id: 'bsi-question-' + topic,
        "aria-expanded": this.openTopic === topic ? 'true' : 'false',
        "aria-controls": 'bsi-answer-' + topic,
        onclick: () => {
          this.openTopic = this.openTopic === topic ? null : topic;
        }
      }, m("span", null, t('home.workbench_' + topic + '_question')), m(BsiIcon, {
        name: "caret-right",
        className: "BsiWorkbench-chevron"
      }))), m("div", {
        className: "BsiWorkbench-answer",
        id: 'bsi-answer-' + topic,
        hidden: this.openTopic !== topic,
        role: "region",
        "aria-labelledby": 'bsi-question-' + topic
      }, m("p", null, t('home.workbench_' + topic + '_answer'))));
    }))), m("div", {
      className: "BsiWorkbench-visual"
    }, m("div", {
      className: "BsiFileDesk",
      "aria-hidden": "true"
    }, m("div", {
      className: "BsiFileDesk-grid"
    }), m("svg", {
      className: "BsiFileDesk-connection",
      viewBox: "0 0 96 104",
      preserveAspectRatio: "none",
      fill: "none",
      focusable: "false"
    }, m("path", {
      d: "M1 31H17Q25 31 25 39V45Q25 53 33 53H40M57 53H63Q71 53 71 61V77Q71 85 79 85H95",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-dasharray": "4 4",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke"
    }), m("path", {
      d: "m89 80 6 5-6 5",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "vector-effect": "non-scaling-stroke"
    })), m("div", {
      className: "BsiFileDesk-item BsiFileDesk-item--original"
    }, m("span", {
      className: "BsiFileDesk-caption"
    }, t('home.workbench_original')), m("div", {
      className: "BsiFileDesk-sheet BsiFileDesk-sheet--original"
    }, m(BsiIcon, {
      name: "file-code"
    }), m("strong", null, t('home.file_label')), m("div", {
      className: "BsiFileDesk-bytes"
    }, Array.from({
      length: 18
    }, (_, index) => m("i", {
      key: index
    }))))), m("span", {
      className: "BsiFileDesk-review"
    }, m(BsiIcon, {
      name: "user-check"
    })), m("div", {
      className: "BsiFileDesk-item BsiFileDesk-item--result"
    }, m("span", {
      className: "BsiFileDesk-caption"
    }, t('home.journey_result')), m("div", {
      className: "BsiFileDesk-sheet BsiFileDesk-sheet--result"
    }, m(BsiIcon, {
      name: "file-code"
    }), m("strong", null, t('home.result_file_label')), m("div", {
      className: "BsiFileDesk-lines"
    }, m("i", null), m("i", null), m("i", null)), m("span", {
      className: "BsiFileDesk-ready"
    }, m(BsiIcon, {
      name: "check"
    }))))), m("p", {
      className: "BsiWorkbench-privacy"
    }, m(BsiIcon, {
      name: "shield-check"
    }), m("span", null, t('home.workbench_privacy')))));
  }
}
flarum.reg.add('bsi-orders', 'forum/components/HomeWorkbench', HomeWorkbench);